<template>
    <v-app v-resize="onResize">

        <v-main class="login-background">
            <system-feedback/>

            <v-container fill-height fluid class="justify-center d-flex flex-column">
                <img :src="cdn_url('core/white_logo.svg')" class="login-logo mb-5" alt="ConnectPlug" />
                <v-card
                    elevation="2"
                    class="align-center login-container"
                >
                    <slot/>
                </v-card>
            </v-container>
        </v-main>

        <simple-modal ref="simple_modal"/>
        <simple-feedback ref="simple_feedback"/>

        <s-footer ref="footer"/>
    </v-app>
</template>

<script>
import {default as SFooter} from '@core-components/pages/structure/Footer';
import SimpleModal from '@core-components/pages/support/SimpleModal';
import SimpleLoading from '@core-components/pages/support/SimpleLoading';
import SystemFeedback from '@core-components/pages/support/SystemFeedback';
import SimpleFeedback from '@core-components/pages/support/SimpleFeedback';

export default {
    components: {
        SFooter,
        SimpleModal,
        SystemFeedback,
        SimpleFeedback,
    },
    data: (vm) => ({
        loading: false,
        onResize: _.debounce(() => {
            vm.mainStyle = { 'padding-bottom': `${vm.$refs.footer.$el.clientHeight}px !important` };
        }, 500),
    }),
    created () {
        this.$bus.$on('simple-modal', (config = {}, loading = false) => {
            this.loading = loading;

            this.$nextTick(() => {
                this.$refs.simple_modal.open(config);
            });
        });

        this.$bus.$on('on-loading', () => {
            this.$bus.$emit('simple-modal', {
                size: 'small',
                persistent: true,
                noFullscreen: true,
                component: SimpleLoading,
                noAction: true,
            }, true);
        });

        this.$bus.$on('off-loading', () => {
            if (!this.loading) return;

            this.loading = false;
            this.$refs.simple_modal.close();
        });

        this.$bus.$on('feedback', (config = {}) => {
            this.$refs.simple_feedback.show(config);
        });
    },
    beforeDestroy () {
        this.$bus.$off('simple-modal');
        this.$bus.$off('on-loading');
        this.$bus.$off('off-loading');
        this.$bus.$off('feedback');
    },
    computed: {
        categoryDivider() {
            return this.categoryTitle || this.categorySubtitle ||
            this.$slots['category-title'] || this.$slots['category-subtitle'];
        },
    },
}
</script>

<style scoped lang="scss">
    $paper-color: var(--v-white-base);
    $paper-border: 1px solid var(--v-neutral-2-base);

    .a4-paper {
        background-color: $paper-color;
        border: $paper-border;
    }

    .login-background {
        background-color: var(--v-app-bar-base);
    }

    .login-logo {
        height: 100px;
    }

    .login-container {
        overflow: hidden;
        padding: 10px 20px 30px;
        width: 400px;
    }

    @media (max-width: 959px) {
        .a4-paper {
            border-top: $paper-border;
            border-bottom: $paper-border;
            border-left: none;
            border-right: none;
        }
    }
</style>
